import axios from 'axios';
import { UserType } from '../context/reducers/useAuthReducer';
import { LOCAL_STORAGE_AUTH_TOKEN } from './../context/AppContext';

export const backend = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development' ? 'http://localhost:3001' : 'https://mt-bringsl-backend.eu-4.evennode.com',
  headers: {},
});

type AuthTokens = {
  authToken: string;
  authTokenExp: number;
  refreshToken: string;
};

export type LoginResponse = AuthTokens & {
  user: UserType;
};

export async function loginUser(username: string, password: string): Promise<LoginResponse> {
  const response = await backend.post<LoginResponse>('/auth/login', { username, password });

  return response.data;
}

export async function refreshAuthToken(refreshToken: string): Promise<LoginResponse> {
  const response = await backend.post<LoginResponse>('/auth/refresh', { refreshToken });

  return response.data;
}

function getToken(): string | null {
  const authToken = localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN);

  return authToken;
}

backend.interceptors.request.use(async (config) => {
  // Use token
  const token = getToken();
  if (token && config.headers) {
    config.headers['Authorization'] = token;
  }

  return config;
});
